
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FnEventFilterComponent } from './fn-event-filter.component';
import { FormsModule } from '@angular/forms';
import { FnInputModule } from '../input/index';
import { CommonModule } from '@angular/common';
import { FnButtonModule } from '../button/index';
import { FnScrollbarModule } from '../scrollbar/index';
import { FnCoreModule } from '../../core/index';
import { FnEventCheckBoxFilterComponent } from './fn-event-check-box-filter/fn-event-check-box-filter.component';



export * from './fn-event-filter.component';
export * from './fn-event-check-box-filter/fn-event-check-box-filter.component';
export * from './fn-event-filter.model';

@NgModule({
  declarations: [FnEventFilterComponent, FnEventCheckBoxFilterComponent],
  imports: [CommonModule, FormsModule, FnInputModule, FnButtonModule, FnScrollbarModule, FnCoreModule.forRoot()],
  exports: [FnEventFilterComponent, FnEventCheckBoxFilterComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FnEventFilterModule {


}

